import { render, staticRenderFns } from "./WarningModal3.vue?vue&type=template&id=516da5fa&scoped=true"
import script from "./WarningModal3.vue?vue&type=script&lang=js"
export * from "./WarningModal3.vue?vue&type=script&lang=js"
import style0 from "./WarningModal3.vue?vue&type=style&index=0&id=516da5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516da5fa",
  null
  
)

export default component.exports